import { defineStore } from 'pinia'

export const usePermissionStore = defineStore('permission', () => {
  const configStore = useConfigStore()
  const { owner, currentTeam, currentTeamPid } = storeToRefs(configStore)

  // Check if we're in demo mode
  const isDemo = computed(() => currentTeamPid.value === 'demo')

  const canAccess = (permission: string) => {
    // Always return true in demo mode
    // NOTE: Development mode bypass temporarily disabled for testing CTA permissions
    // Uncomment the line below to re-enable dev mode bypass:
    // if (import.meta.env.VITE_APP_ENV === 'development' || isDemo.value) {
    if (isDemo.value) {
      return true;
    }

    const accountPermissions = owner.value?.permissions || {}
    const rolePermissions = currentTeam.value?.permissions || {}
    return accountPermissions[permission] || rolePermissions[permission]
  }

  /**
   * Check if user can access a plan feature by name.
   * Uses the plan.features array from the API response rather than gates.
   */
  const canAccessFeature = (feature: string): boolean => {
    if (isDemo.value) return true
    const plan = owner.value?.plan
    if (!plan) return true // Assume access while loading
    if (plan.tier === 'legacy') return true
    return (plan.features ?? []).includes(feature)
  }

  return {
    canAccess,
    canAccessFeature,
    isDemo
  }
})
